export default "__VITE_ASSET__ujSyK_oB__"